<div class="container">
    <div class="row">
        <div class="header">
            <p class="title-1">Repayment Mortgage Calculator</p>
            <p class="title-2">Estimate how much you could be paying for your mortgage during and after your initial term</p>
        </div>
        <div class="col-lg-6" style="margin-bottom: 30px;">
            <div id="section">
                <p class="title-3"><span class="hl">Step 1:</span> Mortgage Details</p>
                <hr>
                <div class='input-section'>
                    <p class="title-4">Property Value</p>
                    <input
                    (input)="calcService.amended = true"
                    [ngModel]="calcService.rm.originalPropertyVal | currency:'GBP':'symbol':'1.0'"
                    [ngModelOptions]="{updateOn:'blur'}"
                    (ngModelChange)="calcService.rm.originalPropertyVal=$event">
                </div>
    
                <div class='input-section'>
                    <p class="title-4">Deposit</p>
                    <div class="slider-container">
                        <mat-slider
                            (input)="calcService.onInputChange($event, 'deposit')"
                            thumbLabel
                            tickInterval="1000"
                            step="1"
                            min="0"
                            max="100"
                            class="slider"
                            [(ngModel)]="calcService.rm.depositVal"
                            aria-label="units">
                        </mat-slider>
                        <div style="display: flex;flex-direction: column;">
                            <p class="title-4" id="slider-label">{{calcService.rm.depositVal}}%</p>
                            <p class="title-4" id="slider-label">{{calcService.getDepositAmount() | currency:'GBP':'symbol':'1.0-0'}}</p>
                        </div>
                    </div>
                </div>
    
                <div class='input-section'>
                    <p class="title-4">Loan Term</p>
                    <div class="slider-container">
                        <mat-slider
                            (input)="calcService.onInputChange($event, 'term')"
                            thumbLabel
                            tickInterval="1000"
                            step="1"
                            min="5"
                            max="40"
                            class="slider"
                            [(ngModel)]="calcService.rm.loanTerm"
                            aria-label="units">
                        </mat-slider>
                        <p class="title-4" id="slider-label">{{calcService.rm.loanTerm}} years</p>
                    </div>
                </div>
    
                <div class='input-section'>
                    <p class="title-4">Initial Term</p>
                    <div class="slider-container">
                        <mat-slider
                            (input)="calcService.onInputChange($event, 'initial-term')"
                            thumbLabel
                            tickInterval="1000"
                            step="1"
                            min="2"
                            max="10"
                            class="slider"
                            [(ngModel)]="calcService.rm.initialTerm"
                            aria-label="units">
                        </mat-slider>
                        <p class="title-4" id="slider-label">{{calcService.rm.initialTerm}} years</p>
                    </div>
                </div>
    
                <div class='input-section'>
                    <p class="title-4">Interest Rate</p>
                    <input
                    (input)="calcService.amended = true"
                    [ngModel]="calcService.rm.interestRate | percent:'1.2'"
                    [ngModelOptions]="{updateOn:'blur'}"
                    (ngModelChange)="calcService.rm.interestRate=$event / 100">
                </div>
    
                <div class='input-section'>
                    <p class="title-4">Mortgage Fee</p>
                    <div class="slider-container">
                        <input
                        (input)="calcService.amended = true"
                        [ngModel]="calcService.rm.mortgageFee | currency:'GBP':'symbol':'1.0'"
                        [ngModelOptions]="{updateOn:'blur'}"
                        (ngModelChange)="calcService.rm.mortgageFee = $event">
                        <mat-checkbox
                            (input)="calcService.amended = true"
                            style="width:150px;display: flex;flex-direction: row;justify-content: end;"
                            class="example-margin"
                            [(ngModel)]="calcService.rm.addFees"
                            [labelPosition]="'right'">
                            Add to loan
                        </mat-checkbox>
                    </div>
                </div>
    
                <div class='input-section'>
                    <p class="title-4">Cashback</p>
                    <input
                    (input)="calcService.amended = true"
                    [ngModel]="calcService.rm.cbAmt | currency:'GBP':'symbol':'1.0'"
                    [ngModelOptions]="{updateOn:'blur'}"
                    (ngModelChange)="calcService.rm.cbAmt=$event">
                </div>
    
                <div class='input-section'>
                    <p class="title-4">Property Type</p>
                    <div class="property-icon-container">
                        <app-property-icon [property]="property" *ngFor="let property of properties"></app-property-icon>
                    </div>
                </div>

            </div>
        </div>
        <div class="col-lg-6" style="margin-bottom: 30px;">
            <div id="section" style="margin-bottom:30px">  
                <p class="title-3"><span class="hl">Step 2:</span> Loan Breakdown</p>
                <hr>
                <app-breakdown-section label="Loan Amount" [value]="calcService.getLoanAmount()" type="currency"></app-breakdown-section>
                <app-breakdown-section label="Deposit" [value]="calcService.getDepositAmount()" type="currency"></app-breakdown-section>
                <app-breakdown-section label="Interest Rate" [value]="calcService.rm.interestRate" type="percent"></app-breakdown-section>
                <app-breakdown-section label="Loan Term" [value]="calcService.rm.loanTerm" type="number"></app-breakdown-section>
                <app-breakdown-section label="Monthly Payment" [value]="calcService.getMonthlyPayment()" type="currency"></app-breakdown-section>
                <app-breakdown-section label="Monthly Increase from Fee" [value]="calcService.getMonthlyFeeImpact()" type="currency"></app-breakdown-section>
                <app-breakdown-section label="Starting LTV" [value]="calcService.getOriginalLTV()" type="percent"></app-breakdown-section>
                <app-breakdown-section label="APRC" [value]="calcService.getAPRC()" type="percent"></app-breakdown-section>
            </div>
            <div id="section">
                <p class="title-3"><span class="hl">Step 3:</span> Adjust Over-payments & HPI</p>
                <hr>
                <div class='input-section'>
                    <p class="title-4">Monthly Overpayment</p>
                    <div class="slider-container">
                        <mat-slider
                            (input)="calcService.onInputChange($event, 'op')"
                            thumbLabel
                            tickInterval="1000"
                            step="50"
                            min="0"
                            [max]="((calcService.getLoanAmount() * 0.1) / 12)"
                            class="slider"
                            [(ngModel)]="calcService.rm.extraPmt"
                            aria-label="units">
                        </mat-slider>
                        <p class="title-4" id="slider-label">{{calcService.rm.extraPmt | currency:'GBP':'symbol':'1.0-0' }}</p>
                    </div>
                </div>
                <div class='input-section'>
                    <p class="title-4">Annual Property Value Increase</p>
                    <div class="slider-container">
                        <mat-slider
                            (input)="calcService.onInputChange($event, 'hpi')"
                            thumbLabel
                            tickInterval="1000"
                            step="0.01"
                            min="0"
                            max="0.5"
                            class="slider"
                            [(ngModel)]="calcService.rm.hpiVal"
                            aria-label="units">
                        </mat-slider>
                        <p class="title-4" id="slider-label">{{calcService.rm.hpiVal | percent:'1.'}}</p>
                    </div>
                </div>
                <app-breakdown-section label="Monthly Overpayment" [value]="calcService.rm.extraPmt" type="currency"></app-breakdown-section>
                <app-breakdown-section label="Total Monthly Payment" [value]="calcService.rm.extraPmt + calcService.calcPmt()" type="currency"></app-breakdown-section>
                <app-breakdown-section label="Total Interest Saved" [value]="calcService.calcInterestSaved()" type="currency"></app-breakdown-section>
                <app-breakdown-section label="Total Years Saved" [value]="this.calcService.calcNumPaymentsSaved() / 12" type="number"></app-breakdown-section>
                <app-breakdown-section [years]="this.calcService.rm.initialTerm" [value]="this.calcService.calcLtv()" type="percent"></app-breakdown-section>
                <p class="title-5" style="font-style: italic;margin-top:10px">Most lenders only let you overpay by up to 10% of the outstanding loan each year during your initial term, so we’ve set the maximum monthly amount you could overpay by.</p>
            </div>
        </div>
    </div>
</div>